import 'utils/jquery';
import { setAuthFromLocal } from 'actions';
import { loadFeatureFlags } from 'reducers/featureFlags/actions';
import getMokaUserEmail from 'selectors/getMokaUserEmail';
import getMokaUserId from 'selectors/getMokaUserId';
import createRoutes from './routes';
import createReduxStore from './createReduxStore';

const store = createReduxStore();

/*
 * Retrieving auth information from local storage into store upfront so that
 * feature flag provider can have this information.
 *
 * After this action, the app is auth-ready. If there is no session, user will
 * be redirected in `onEnterProtectedRoute`.
 *
 * TODO: Once we have cleaned up routes.js, auth information should be
 *       wrapped in an AuthProvider for better management.
 */
store.dispatch(setAuthFromLocal());

const state = store.getState();
const userId = getMokaUserId(state);
const email = getMokaUserEmail(state);
store.dispatch(
  loadFeatureFlags(userId, {
    email,
  })
);

// Set user identification for UserGuiding
window.userGuiding?.identify(userId);

const MokaBackofficeRoutes = createRoutes(store);
export default MokaBackofficeRoutes;
